"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
  }
  return t;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = require("react");

var component_1 = require("./");

var data_1 = require("../data");

exports.initialPredictedContactMapState = {
  linearDistFilter: 5,
  numPredictionsToShow: -1,
  pointsToPlot: []
};

var PredictedContactMap =
/** @class */
function (_super) {
  __extends(PredictedContactMap, _super);

  function PredictedContactMap(props) {
    var _this = _super.call(this, props) || this;

    _this.state = exports.initialPredictedContactMapState;

    _this.onLinearDistFilterChange = function () {
      return function (value) {
        _this.setState({
          linearDistFilter: value
        });
      };
    };

    _this.onNumPredictionsToShowChange = function () {
      return function (value) {
        _this.setState({
          numPredictionsToShow: value
        });
      };
    };

    _this.getContactMapConfigs = function () {
      return [{
        name: 'Linear Distance Filter (|i - j|)',
        onChange: _this.onLinearDistFilterChange(),
        type: data_1.CONFIGURATION_COMPONENT_TYPE.SLIDER,
        values: {
          current: _this.state.linearDistFilter,
          max: 10,
          min: 1
        }
      }, {
        name: 'Top N Predictions to Show',
        onChange: _this.onNumPredictionsToShowChange(),
        type: data_1.CONFIGURATION_COMPONENT_TYPE.SLIDER,
        values: {
          current: _this.state.numPredictionsToShow,
          max: _this.props.data.couplingScores.chainLength,
          min: 1
        }
      }];
    };

    return _this;
  }

  PredictedContactMap.prototype.componentDidMount = function () {
    this.setupData(true);
  };

  PredictedContactMap.prototype.componentDidUpdate = function (prevProps, prevState) {
    var data = this.props.data;
    var _a = this.state,
        linearDistFilter = _a.linearDistFilter,
        numPredictionsToShow = _a.numPredictionsToShow;
    var isRecomputeNeeded = data.couplingScores !== prevProps.data.couplingScores || linearDistFilter !== prevState.linearDistFilter || numPredictionsToShow !== prevState.numPredictionsToShow;

    if (isRecomputeNeeded) {
      this.setupData(data.couplingScores !== prevProps.data.couplingScores);
    }
  };

  PredictedContactMap.prototype.render = function () {
    var _a = this.props,
        data = _a.data,
        style = _a.style,
        passThroughProps = __rest(_a, ["data", "style"]);

    var pointsToPlot = this.state.pointsToPlot;
    return React.createElement("div", {
      className: "PredictedContactMapComponent",
      style: style
    }, React.createElement(component_1.ContactMap, __assign({
      configurations: this.getContactMapConfigs(),
      data: {
        couplingScores: data.couplingScores,
        pdbData: data.pdbData,
        secondaryStructures: data.pdbData ? data.pdbData.secondaryStructureSections : []
      },
      formattedPoints: pointsToPlot
    }, passThroughProps)));
  };
  /**
   * Setups up the prediction values for the data.
   *
   * @param isNewData Is this an entirely new dataset?
   */


  PredictedContactMap.prototype.setupData = function (isNewData) {
    var _a = this.props,
        correctColor = _a.correctColor,
        data = _a.data,
        incorrectColor = _a.incorrectColor;
    var _b = this.state,
        linearDistFilter = _b.linearDistFilter,
        numPredictionsToShow = _b.numPredictionsToShow;
    var couplingScores = data.pdbData ? data.pdbData.contactInformation : new data_1.CouplingContainer(data.couplingScores.rankedContacts);
    var chainLength = couplingScores.chainLength;
    var allPredictions = couplingScores.getPredictedContacts(numPredictionsToShow, linearDistFilter);
    var correctPredictionPercent = (allPredictions.correct.length / allPredictions.predicted.length * 100).toFixed(1);
    var newPoints = [component_1.generateChartDataEntry('text', incorrectColor, 'Predicted Contact', "(N=" + numPredictionsToShow + ", L=" + chainLength + ")", 4, allPredictions.predicted, {
      text: allPredictions.predicted.map(function (point) {
        var score = data.couplingScores.getCouplingScore(point.i, point.j);
        return score && score.A_i && score.A_j ? "(" + point.i + score.A_i + ", " + point.j + score.A_j + ")" : "(" + point.i + ", " + point.j + ")";
      })
    }), component_1.generateChartDataEntry('text', correctColor, 'Correct Prediction', "(N=" + allPredictions.correct.length + ", " + correctPredictionPercent + "%)", 6, allPredictions.correct, {
      text: allPredictions.correct.map(function (point) {
        var score = data.couplingScores.getCouplingScore(point.i, point.j);
        return score && score.A_i && score.A_j ? "(" + point.i + score.A_i + ", " + point.j + score.A_j + ")" : "(" + point.i + ", " + point.j + ")";
      })
    })];
    this.setState({
      numPredictionsToShow: isNewData ? Math.floor(chainLength / 2) : numPredictionsToShow,
      pointsToPlot: newPoints
    });
  };

  PredictedContactMap.defaultProps = {
    correctColor: '#ff0000',
    data: {
      couplingScores: new data_1.CouplingContainer(),
      secondaryStructures: new Array()
    },
    height: '100%',
    incorrectColor: '#000000',
    isDataLoading: false,
    width: '100%'
  };
  return PredictedContactMap;
}(React.Component);

exports.PredictedContactMap = PredictedContactMap;